import type { User } from 'firebase/auth';
import { onAuthStateChanged } from 'firebase/auth';
import { firebaseAuthService } from '@/core/services';

/**
 * Inscreve-se nas mudanças de estado do Firebase Auth.
 * Retorna função para cancelar a inscrição.
 */
export class ObservarEstadoAuthUseCase {
  execute(callback: (user: User | null) => void): () => void {
    const auth = firebaseAuthService.getAuth();
    return onAuthStateChanged(auth, callback);
  }
}
